import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  CssBaseline,
  Button,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { logout } from '../api/Auth';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import SecureLS from 'secure-ls'

const ls = new SecureLS({encodingType: 'aes'})

const Dashboard = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { text: 'Home', path: '/admin/applicants' },
  ];

  useEffect(() => {
    const jwt = ls.get('jwt');
    if (!jwt) {
        navigate('/login');
        return
    }
    // check for jwt
  }, [navigate]);


  const handleLogout = async () => {
    await logout();
    ls.remove('jwt');
    navigate('/login');
  };

  // Toggle Drawer
  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

       {/* AppBar */}
       <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            sx={{ mr: 2 }}
          >
            <Icon icon="material-symbols:menu" />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            APEX Admin Dashboard
          </Typography>
          <Button
            color="inherit"
            startIcon={<Icon icon="material-symbols:logout" />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        variant="temporary"
        open={drawerOpen}
        onClose={closeDrawer}
        sx={{
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
        }}
      >
        <Toolbar />
        <List>
          {navItems.map(item => (
            <ListItem 
              button 
              key={item.text}
              selected={location.pathname === item.path}
              sx={{
                backgroundColor: location.pathname === item.path ? '#e8e8e8' : 'unset',
              }}
              onClick={() => {
                navigate(item.path);
                setDrawerOpen(false);
              }}
            >
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Outlet />
      </Box>

      </Box>
  );
};

export default Dashboard;
